import { Col, Collapse, Row } from "antd";

import PageDataImportTemplateContent from "./components/PageDataImportTemplateContent";
import PageDataImportContent from "./components/PageDataImportContent";
import useWindowDimensions from "../../../../providers/useWindowDimensions";

export default function PageSystemSettingsDataImport() {
	const { width } = useWindowDimensions();

	return (
		<div className="custom-width-dsk">
			<Row className="data_import_content ant-row-custom">
				<Col
					xs={24}
					sm={24}
					md={24}
					lg={24}
					// xl={16}
					// xxl={16}
					className=""
					// className="ant-row-custom"
				>
					<Collapse
						defaultActiveKey={["0", "1"]}
						items={[
							{
								key: "0",
								label: "Template Downloads & Imports",
								children: <PageDataImportTemplateContent width={width} />,
							},
							{
								key: "1",
								label: "Imports",
								children: <PageDataImportContent width={width} />,
							},
						]}
					/>
				</Col>
			</Row>
		</div>
	);
}
